import { CloseIcon } from "../../../common/functions";

// Editable fields organized by category
let editableFields = {
  identification: ["BB Ticker", "ISIN", "CUSIP", "Bloomberg ID"],
  position: ["Type", "Strategy", "Location", "Currency", "Notional Amount", "Average Cost"],
  pricing: ["Mid", "Bid", "Ask", "FX Rate", "YTM", "YTW", "Bloomberg Mid BGN"],
  dates: ["Maturity", "Call Date", "Previous Settle Date", "Next Settle Date"],
  ratings: ["BBG Composite Rating", "S&P Bond Rating", "S&P Outlook", "Moody's Bond Rating", "Moody's Outlook", "Fitch Bond Rating", "Fitch Outlook"],
  details: ["Issuer", "Sector", "Country", "Issuer's Country", "Asset Class", "Broker"],
  coupon: ["Coupon Rate", "PIK Coupon Rate", "Coupon Duration", "Coupon Frequency", "Original Face"],
  risk: ["DV01", "CR01", "OAS", "Z Spread"],
  // Optional CDS metadata; ignored for non-CDS positions. Coupon Rate / DV01
  // / CR01 (under coupon/risk groups) carry the CDS-specific values for CDS
  // rows (preset coupon, Spread DV01, Default Exposure respectively).
  cds: ["CDS Factor", "CDS Recovery Rate", "CDS Last Coupon Date"],
  other: ["Tax", "Pin", "Notes", "Security Description", "Entry Yield"],
  event: ["Event Type", "Factor Date (if any)", "Edit Note"]
};

function EditPosition(props: any) {
  if (!props.position["BB Ticker"]) {
    return <div></div>;
  }

  let renderField = (title: string, index: number) => {
    if (title === "Event Type") {
      return (
        <select name="Event Type" className="edit-position-input">
          <option value="edit_position">Edit Position</option>
          <option value="sink_factor">Sink Factor</option>
          <option value="pay_in_kind">Pay In Kind</option>
          <option value="settlement_position">Settlement Edit</option>
          <option value="redemption">Redemption</option>
        </select>
      );
    } else if (title === "Edit Note") {
      return <input type="text" name={title} placeholder="Enter note (required)" className="edit-position-input" required />;
    } else if (title === "Factor Date (if any)") {
      return <input type="date" name={title} className="edit-position-input" />;
    } else {
      let value = props.position[title];
      let displayValue = value !== undefined && value !== null ? String(value) : "";
      return <input type="text" name={title} defaultValue={displayValue} className="edit-position-input" />;
    }
  };

  let renderSection = (sectionTitle: string, fields: string[]) => {
    let visibleFields = fields.filter(f => !props.unEditableParams.includes(f));
    if (visibleFields.length === 0) return null;
    
    return (
      <div className="edit-section" key={sectionTitle}>
        <div className="edit-section-title">{sectionTitle}</div>
        <div className="edit-section-fields">
          {visibleFields.map((title, index) => (
            <div className="edit-field-row" key={title}>
              <label className="edit-field-label">{title}</label>
              {renderField(title, index)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="edit-position-modal">
      <div className="edit-position-header">
        <h3 className="edit-position-title">Edit Position: {props.position["BB Ticker"]}</h3>
        <div onClick={(event) => props.cancelPositionInfo(event)} className="close-icon-container-edit-position">
          <CloseIcon />
        </div>
      </div>
      
      <form id="edit-position" onSubmit={(event) => props.handleEditPosition(event)}>
        {/* Hidden field for position ID */}
        <input type="hidden" name="id" value={props.position["id"]} />
        
        <div className="edit-position-grid">
          {renderSection("Event", editableFields.event)}
          {renderSection("Position", editableFields.position)}
          {renderSection("Pricing", editableFields.pricing)}
          {renderSection("Dates", editableFields.dates)}
          {renderSection("Details", editableFields.details)}
          {renderSection("Coupon", editableFields.coupon)}
          {renderSection("Risk", editableFields.risk)}
          {props.position["Type"] === "CDS" ? renderSection("CDS", editableFields.cds) : null}
          {renderSection("Ratings", editableFields.ratings)}
          {renderSection("Other", editableFields.other)}
        </div>

        <div className="edit-position-footer">
          <button type="button" className="btn btn-cancel" onClick={(event) => props.cancelPositionInfo(event)}>
            Cancel
          </button>
          <button type="submit" className="btn upload-btn">
            Save Changes
          </button>
        </div>
      </form>
      
      {props.authStatus && <div className="edit-position-error">{props.authStatus}</div>}
    </div>
  );
}

export default EditPosition;
